import React from "react";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import InputText from "../../../../components/modalComponents/InputText";
import InputUploadFile from "../../../../components/modalComponents/InputUploadFile";
import InputNumber from "../../../../components/modalComponents/InputNumber";
import {EXTENSIONES_VALIDAS_DE_IMAGENES} from "../../../../constants/hardCodedConstants";
import InputTextArea from "../../../../components/modalComponents/InputTextArea";
import InputSelect from "../../../../components/modalComponents/InputSelect";

const BaseItem = ({
                      toggleModal,
                      title,
                      puedeEditar,
                      sectionName,
                      KEYS,
                      formValues,
                      setFormValues,
                      commonProps,
                      isUploading,
                      setIsUploading,
                      isSubmitting,
                      handleSubmit,
                      selectProps
                  }) => {

    return (
        <ModalForm
            onSubmit={handleSubmit}
            showModal={toggleModal}
            width="700px"
            titulo={title}
            saveButtonDisabled={isUploading}
            isSubmitting={isSubmitting}>
            <InputText
                label="Descripción"
                {...commonProps(KEYS.Descripcion)}
                direction="column"
                isDisabled={!puedeEditar || isSubmitting || isUploading}
            />

            <InputSelect
                direction="column"
                label="Tipo"
                {...selectProps(KEYS.IdTipoBeneficioItem)}
                sectionName={sectionName}
                isDisabled={false}
                isRequired={true}
                hasValidationMessage={true}
                placeholder={"Seleccionar Tipo"}
            />

            <InputSelect
                direction="column"
                label="Ubicación"
                {...selectProps(KEYS.IdUbicacionBeneficioItem)}
                sectionName={sectionName}
                isDisabled={false}
                isRequired={true}
                hasValidationMessage={true}
                placeholder={"Seleccionar Ubicación"}
            />

            <InputNumber
                label="Monto"
                {...commonProps(KEYS.Monto)}
                direction="column"
                isDisabled={!puedeEditar || isSubmitting || isUploading}
            />

            <InputTextArea
                label="Detalle"
                {...commonProps(KEYS.Detalle)}
                direction="column"
                isDisabled={!puedeEditar || isSubmitting || isUploading}
                rows={4}
            />

            <InputUploadFile
                label="Imagen"
                name={KEYS.ImagenBeneficio}
                uploadFile={formValues[KEYS.ImagenBeneficio]}
                setUploadFile={(res) =>
                    setFormValues({...formValues, [KEYS.ImagenBeneficio]: res})
                }
                sectionName={sectionName}
                setIsUploading={setIsUploading}
                validExtensions={EXTENSIONES_VALIDAS_DE_IMAGENES}
                direction="column"
                toolTipText="Se recomienda utilizar una de 600 x 600 px"
                NoFileMessage={isUploading ? "Subiendo archivo..." : "No se ha subido archivo"}
                isDisabled={!puedeEditar || isSubmitting || isUploading}
            />
        </ModalForm>
    );
};

export default BaseItem;